<template>
  <modal :showCloseIcon="true" @send="doUpdate" v-on="$listeners">
    <div slot="header" class="emphasize">Edit Nominee</div>
    <div slot="body" class="row">
      <div class="col-sm-12">
        <ttw-input disabled="disabled" v-model="nomineeName" label="Name" />
      </div>
      <div class="col-sm-6">
        <ttw-input
          v-model="passportNo"
          :input-validator="validatePassport"
          :key-validator="isAlphabetKey"
          label="Passport Number"
          placeholder="Passport Number"
        />
      </div>
      <div class="col-sm-6">
        <ttw-datepicker v-model="passportExp" :min="expMin" label="Passport Expiry Date" />
      </div>
      <div class="col-xs-12">
        <ttw-button @click="doUpdate" value="Update" />
      </div>
    </div>
  </modal>
</template>
<script>
import moment from "moment";
import text from "../../core/text";
import Modal from "@/components/layout/Modal";
import { mapState, mapMutations } from "vuex";
import { isAlphabetKey, validatePassport } from "../../core/validator";
export default {
  extends: Modal,
  components: {
    Modal
  },
  created() {
    this.setDefault(this.nomineeId);
  },
  data() {
    return {
      nominee: null,
      passportNo: null,
      passportExp: null,
      nomineeName: null,
      expMin: moment().format("YYYY-MM-DD")
    };
  },
  props: {
    nomineeId: String
  },
  methods: {
    doUpdate() {
      this.$staff
        .updateNominee(this.token, {
          uuid: this.nomineeId,
          expiryDate: this.passportExp,
          passportNumber: this.passportNo
        })
        .then(() => {
          this.updateNominee({
            id: this.nomineeId,
            passportNo: this.passportNo,
            passportExp: this.passportExp
          });
          this.$emit("complete");
        })
        .catch(ex =>
          this.setMessagePopup({
            message: ex.message,
            title: text.errorMessageTitle
          })
        );
    },
    setDefault(nomineeId) {
      if (nomineeId) {
        let nominee = this.nominees.find(n => n.uuid == nomineeId);
        if (nominee) {
          this.nominee = nominee;
          this.passportNo = nominee.passportNumber;
          this.nomineeName = `${nominee.firstName} ${nominee.lastName}`;
          let mo = nominee.expiryDate
            ? moment(new Date(nominee.expiryDate))
            : moment().add(3, "months");
          this.passportExp = mo.format("YYYY-MM-DD");
        }
      }
    },
    isAlphabetKey: isAlphabetKey,
    validatePassport: validatePassport,
    ...mapMutations(["updateNominee", "setMessagePopup"])
  },
  watch: {
    nomineeId: function(newVal) {
      this.setDefault(newVal);
    }
  },
  computed: {
    ...mapState({
      token: s => s.token,
      nominees: s => s.nominees
    })
  }
};
</script>
<style lang="scss" scoped>
.form-group {
  width: 100%;
}
</style>